import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiPaths } from '../../enums/api-paths';
import { LoginRequest } from '../../models/login-request';
import { TokenService } from '../token/token.service';
import { Roles } from '../../enums/roles';
import { RegistrationRequest } from '../../models/registration-request';
import { EmailVerificationRequest } from '../../models/email-verification-request';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService
  ) {}

  login(loginRequest: LoginRequest): Observable<object> {
    return this.httpClient.post(ApiPaths.LOGIN_URL, loginRequest, {
      withCredentials: true,
    });
  }

  verifyUser(): Observable<object> {
    return this.httpClient.get(ApiPaths.VERIFY_USER_URL, {
      withCredentials: true,
    });
  }

  verifyEmail(
    emailVerificationRequest: EmailVerificationRequest
  ): Observable<object> {
    return this.httpClient.post(
      ApiPaths.EMAIL_VERIFICATION_URL,
      emailVerificationRequest,
      {
        withCredentials: true,
      }
    );
  }

  invalidateTokens(): Observable<object> {
    return this.httpClient.get(ApiPaths.INVALIDATE_TOKENS_URL, {
      withCredentials: true,
    });
  }

  isUser(): boolean {
    return this.tokenService.getRoleFromToken() === Roles.USER;
  }

  isAdmin(): boolean {
    return this.tokenService.getRoleFromToken() === Roles.ADMIN;
  }

  isAuthenticated(): boolean {
    return this.isUser() || this.isAdmin();
  }

  isEmailVerified(): boolean {
    return this.tokenService.isEmailVerified();
  }
}
